/* Issue #52: compact the Klaviyo star-rating label on product cards to "4.8 (55)".
   Klaviyo renders "55 reviews"; the rating value is only exposed via aria-label. */
(function () {
  if (window.__gsCardRatingCompact) return;
  window.__gsCardRatingCompact = true;

  var pattern = /([\d.]+)\s+stars?,\s+(\d+)\s+review/i;

  function compact(widget) {
    var link = widget.querySelector('.kl_reviews__star_rating_widget');
    if (!link || link.getAttribute('data-gs-compact') === '1') return;
    var match = pattern.exec(link.getAttribute('aria-label') || '');
    var label = link.querySelector('.kl_reviews__star_rating_widget__label');
    if (!match || !label) return;
    label.textContent = match[1] + ' (' + match[2] + ')';
    link.setAttribute('data-gs-compact', '1');
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    var widgets = document.querySelectorAll('.product-card .klaviyo-star-rating-widget');
    for (var i = 0; i < widgets.length; i += 1) compact(widgets[i]);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(scan);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
